import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

//import Charts
import StackedColumnChart from "../../Dashboard/StackedColumnChart";

import modalimage1 from "../../../assets/images/product/img-7.png";
import modalimage2 from "../../../assets/images/product/img-4.png";
import '../../../assets/css/pages/Dashboard.css'

//import action
import { getChartsData } from "../../../store/actions";

// Pages Components
import WelcomeComp from "../../Dashboard/WelcomeComp";
import MonthlyEarning from "../../Dashboard/MonthlyEarning";
import SocialSource from "../../Dashboard/SocialSource";
import ActivityComp from "../../Dashboard/ActivityComp";
import TopCities from "../../Dashboard/TopCities";
import LatestTranaction from "../../Dashboard/LatestTranaction";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import { FaUser, FaUserDoctor } from "react-icons/fa6";
import { FaRegFileAlt } from "react-icons/fa";
import { AdminDashboardRes, AdminDashboardTodo } from "redux/slice/admin/dashboard/AdminDashboard";
import BarChartPatho from "./BarChartPatho";
import PieChartPath from "./PieChartPath";
import List from "./List";

class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spiner: false
      // reports: [
      //   { title: "Orders", iconClass: "bx-copy-alt", description: "1,235" },
      //   {
      //     title: "Revenue",
      //     iconClass: "bx-archive-in",
      //     description: "$35, 723",
      //   },
      //   {
      //     title: "Average Price",
      //     iconClass: "bx-purchase-tag-alt",
      //     description: "$16.2",
      //   },
      // ],
      // email: [
      //   { title: "Week", linkto: "#", isActive: false },
      //   { title: "Month", linkto: "#", isActive: false },
      //   { title: "Year", linkto: "#", isActive: true },
      // ],
      // modal: false,
      // subscribemodal: false,
      // chartSeries: [],
      // periodType: "yearly",
    };

    // this.togglemodal.bind(this);
    // this.togglesubscribemodal.bind(this);
  }

  // componentDidMount() {
  //   const { onGetChartsData } = this.props;
  //   setTimeout(() => this.setState({ subscribemodal: true }), 2000);
  //   onGetChartsData("yearly");
  // }

  // togglemodal = () => {
  //   this.setState(prevState => ({
  //     modal: !prevState.modal,
  //   }));
  // };

  // togglesubscribemodal = () => {
  //   this.setState(prevState => ({
  //     subscribemodal: !prevState.subscribemodal,
  //   }));
  // };

  componentDidMount() {
    const { dispatch } = this.props;
    this.setState({ spiner: true });
    dispatch(AdminDashboardTodo()).then(() => this.data_res())

  }

  data_res = () => {
    if (AdminDashboardRes?.success) {
      this.setState({ spiner: false });
    }  else if (AdminDashboardRes?.error?.success == 401) {
      localStorage.clear()
      this.props.history.push('/admin/login');
  } else {
      this.setState({ spiner: false });
    }
  }

  render() {
    //meta title
    // document.title = "Dashboard | Skote - React Admin & Dashboard Template";
    const { DashboardData } = this.props

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            {/* <Breadcrumbs
              title={this.props.t("Dashboards")}
              breadcrumbItem={this.props.t("Dashboard")}
            /> */}
            <h4 className="mb-0 font-size-18"> Dashboard</h4>
            <Row>
              {/* <Col xl="4">
                <WelcomeComp />
                <MonthlyEarning />
              </Col> */}
              <Col xl="12" className="mt-3">
                <Row>
                  <Col md="4">
                    <Card className="mini-stats-wid dashboard_card">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted  fw-medium">
                              Doctors
                            </p>
                            <h4 className="mb-0">{DashboardData?.TotalDoctor ? DashboardData?.TotalDoctor : "0"}</h4>
                          </div>
                          <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                            <span className="avatar-title">
                              <FaUserDoctor className='' style={{ color: "white" }} size={20} />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card className="mini-stats-wid dashboard_card">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              Patient
                            </p>
                            <h4 className="mb-0">{DashboardData?.TotalPatient ? DashboardData?.TotalPatient : '0'}</h4>
                          </div>
                          <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                            <span className="avatar-title">
                              <FaUser className='' style={{ color: "white" }} size={20} />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card className="mini-stats-wid dashboard_card">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              Test
                            </p>
                            <h4 className="mb-0">{DashboardData?.TotalTest ? DashboardData?.TotalTest : '0'}</h4>
                          </div>
                          <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                            <span className="avatar-title">
                              <FaRegFileAlt className='' style={{ color: "white" }} size={20} />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  {/* ))} */}
                </Row>


                {/* <Card>
                  <CardBody>
                    <div className="d-sm-flex flex-wrap">
                      <CardTitle className="card-title mb-4 h4">
                        Email Sent
                      </CardTitle>
                      <div className="ms-auto">
                        <ul className="nav nav-pills">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { active: this.state.periodType === "weekly" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  periodType: "weekly",
                                });
                                this.props.onGetChartsData("weekly");
                              }}
                              id="one_month"
                            >
                              Week
                            </Link>{" "}
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { active: this.state.periodType === "monthly" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  periodType: "monthly",
                                });
                                this.props.onGetChartsData("monthly");
                              }}
                              id="one_month"
                            >
                              Month
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { active: this.state.periodType === "yearly" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  periodType: "yearly",
                                });
                                this.props.onGetChartsData("yearly");
                              }}
                              id="one_month"
                            >
                              Year
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="clearfix" />
                    <StackedColumnChart chartSeries={this.state.chartSeries} />
                  </CardBody>
                </Card> */}
              </Col>
            </Row>

            {/* <Row>
              <Col xl="4">
                <SocialSource />
              </Col>
              <Col xl="4">
                <ActivityComp />
              </Col>
              <Col xl="4">
                <TopCities />
              </Col>
            </Row> */}
            <Row>
              <div className="col-md-7">
                <h4 className="mb-0 font-size-18">Month Wise Report</h4>
                <div className="dashboard_graph match_height mt-2">
                  <BarChartPatho />
                </div>
              </div>
              <div className="col-md-5">
                <h4 className="mb-0 font-size-18">Doctor Wise Test</h4>
                <div className="dashboard_graph match_height mt-2">
                  <PieChartPath />
                </div>
              </div>
              <div className="col-md-6 mt-5">
                <h4 className="mb-0 font-size-18">Top 10 Test </h4>
                <div className="dashboard_graph match_height mt-2">
                  <List />
                </div>
              </div>
            </Row>
          </Container>
        </div>

        {/* <Modal
          isOpen={this.state.subscribemodal}
          role="dialog"
          autoFocus={true}
          data-toggle="modal"
          centered
          toggle={this.togglesubscribemodal}
        >
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                type="button"
                className="btn-close"
                onClick={() => this.setState({ subscribemodal: false })}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="text-center mb-4">
                <div className="avatar-md mx-auto mb-4">
                  <div className="avatar-title bg-light  rounded-circle text-primary h1">
                    <i className="mdi mdi-email-open"></i>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <h4 className="text-primary">Subscribe !</h4>
                    <p className="text-muted font-size-14 mb-4">
                      Subscribe our newletter and get notification to stay
                      update.
                    </p>

                    <div className="input-group  rounded bg-light">
                      <Input
                        type="email"
                        className="form-control bg-transparent border-0"
                        placeholder="Enter Email address"
                      />
                      <Button color="primary" type="button" id="button-addon2">
                        <i className="bx bxs-paper-plane"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.modal}
          role="dialog"
          autoFocus={true}
          centered={true}
          className="exampleModal"
          tabindex="-1"
          toggle={this.togglemodal}
        >
          <div className="modal-content">
            <ModalHeader toggle={this.togglemodal}>Order Details</ModalHeader>
            <ModalBody>
              <p className="mb-2">
                Product id: <span className="text-primary">#SK2540</span>
              </p>
              <p className="mb-4">
                Billing Name:{" "}
                <span className="text-primary">Neal Matthews</span>
              </p>

              <div className="table-responsive">
                <Table className="table align-middle table-nowrap">
                  <thead>
                    <tr>
                      <th scope="col">Product</th>
                      <th scope="col">Product Name</th>
                      <th scope="col">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <div>
                          <img src={modalimage1} alt="" className="avatar-sm" />
                        </div>
                      </th>
                      <td>
                        <div>
                          <h5 className="text-truncate font-size-14">
                            Solid Color T-Shirt
                          </h5>
                          <p className="text-muted mb-0">$ 225 x 1</p>
                        </div>
                      </td>
                      <td>$ 255</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div>
                          <img src={modalimage2} alt="" className="avatar-sm" />
                        </div>
                      </th>
                      <td>
                        <div>
                          <h5 className="text-truncate font-size-14">
                            Hoodie (Blue)
                          </h5>
                          <p className="text-muted mb-0">$ 145 x 1</p>
                        </div>
                      </td>
                      <td>$ 145</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <h6 className="m-0 text-right">Sub Total:</h6>
                      </td>
                      <td>$ 400</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <h6 className="m-0 text-right">Shipping:</h6>
                      </td>
                      <td>Free</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <h6 className="m-0 text-right">Total:</h6>
                      </td>
                      <td>$ 400</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                color="secondary"
                onClick={this.togglemodal}
              >
                Close
              </Button>
            </ModalFooter>
          </div>
        </Modal> */}
      </React.Fragment>
    );
  }
}

// AdminDashboard.propTypes = {
//   t: PropTypes.any,
//   chartsData: PropTypes.any,
//   // onGetChartsData: PropTypes.func,
// };

const mapStateToProps = state => ({
  DashboardData: state?.AdminDashboard?.data?.data,

  // departmentListRes: state.DepartmentListRes // Adjust based on where `departmentListRes` is stored
});

// const mapDispatchToProps = dispatch => ({
//   onGetChartsData: periodType => dispatch(getChartsData(periodType)),
// });

export default connect(mapStateToProps)(AdminDashboard);
